import { Checkbox, useFilter } from '@rewardops/ui'

import { handleEnterKeyPress } from '~/utils/event-handler-utils'
import { useTranslation } from '~/app/i18n/client'

export const UserBalanceFilter = ({ onApply }: { onApply?: Function }) => {
  const { t } = useTranslation()
  const { onlyItemsWithinBalance, setOnlyItemsWithinBalance } = useFilter()

  return (
    <div className="flex flex-col gap-2">
      <div className="flex flex-row gap-3">
        <div
          id="user-balance-filter-checkbox"
          key="user-balance-filter-checkbox"
          role="button"
          tabIndex={0}
          className="flex cursor-pointer items-center space-x-2 font-normal"
          onKeyDown={(e) => {
            handleEnterKeyPress(e, () => {
              setOnlyItemsWithinBalance(!onlyItemsWithinBalance)
            })
            onApply && onApply()
          }}
          onClick={(e) => {
            e.preventDefault()
            setOnlyItemsWithinBalance(!onlyItemsWithinBalance)
            onApply && onApply()
          }}
        >
          <Checkbox checked={onlyItemsWithinBalance} />
          <div className="cursor-pointer">
            {t('filters.itemsAtOrBelowBalance')}
          </div>
        </div>
      </div>
    </div>
  )
}
